<block-ui>
    <form class="row mb-3" [formGroup]="SearchForm">
        <div class="col">
            <label class="">Cédula:</label>
            <input type="text" class="form-control form-control-sm" formControlName="Card" (change)="LoadPersonCardPagedCount()">
        </div>
        <div class="col">
            <label class="">Usuario:</label>
            <input type="text" class="form-control form-control-sm" formControlName="User" (change)="LoadPersonCardPagedCount()">
        </div>
        <div class="col">
            <label class="">Actualización desde:</label>
            <input type="date" class="form-control form-control-sm" formControlName="From" (change)="ValidateDate('From')" (blur)="(search)?LoadPersonCardPagedCount():false">
        </div>
        <div class="col">
            <label class="">Actualización hasta:</label>
            <input type="date" class="form-control form-control-sm" formControlName="To" (change)="ValidateDate('To')" (blur)="(search)?LoadPersonCardPagedCount():false">
        </div>
        <div class="col">
            <label class="">Estado</label>
            <select class="form-control form-control-sm" formControlName="State" (change)="LoadPersonCardPagedCount()">
                <option value="" selected>Todos</option>
                <option value="0">Sin procesar</option>
                <option value="1">Procesado</option>
                <option value="2">Procesado con Errores</option>
            </select>
        </div>
        <div class="col">
            <label class="">Activa</label>
            <select class="form-control form-control-sm" formControlName="Active" (change)="LoadPersonCardPagedCount()">
                <option value="" selected>Todas</option>
                <option value="1">Si</option>
                <option value="0">No</option>
            </select>
        </div>
        <div class="d-flex align-items-end mr-3">
            <div class="d-flex flex-row-reverse">
                <button type="button" class="btn btn-light shadow-sm btn-sm" (click)="LoadPersonCardPagedCount()">Buscar</button>
            </div>
        </div>
        <div class="d-flex align-items-end mr-3">
            <div class="d-flex flex-row-reverse">
                <button type="button" class="btn btn-light shadow-sm btn-sm" (click)="AddPersonCard(content_person_card)">Agregar Cédula</button>
            </div>
        </div>
        <div class="d-flex align-items-end mr-3">
            <div class="d-flex flex-row-reverse">
                <button type="button" class="btn btn-light shadow-sm btn-sm" (click)="RaiseUploadCardsModal(content_upload_cards)">Cargar archivo</button>
            </div>
        </div>
    </form>
    <div class="tableFixHead mt-2">
        <table class="table table-striped table-sm">
            <thead style="background-color: #172749; color: white;">
                <tr>
                    <th scope="col" style="position: sticky; top: 0;">#</th>
                    <th scope="col" style="position: sticky; top: 0;">Cédula</th>
                    <th scope="col" style="position: sticky; top: 0;">Agregada por</th>
                    <th scope="col" style="position: sticky; top: 0;">Modificada por</th>
                    <th scope="col" style="position: sticky; top: 0;">Agregada</th>
                    <th scope="col" style="position: sticky; top: 0;">Modificada</th>
                    <th scope="col" style="position: sticky; top: 0;">Errores</th>
                    <th scope="col" style="position: sticky; top: 0;">Estado</th>
                    <th scope="col" style="position: sticky; top: 0;">Activa</th>
                    <th scope="col" style="position: sticky; top: 0;">Opciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let PersonCard of PersonCards; let i = index" class="p-0">
                    <td scope="row">{{(i + 1 + ((CurrentPage-1)*PageSize))}}</td>
                    <td>{{PersonCard.Card}}</td>
                    <td>{{PersonCard.CreateUser}}</td>
                    <td>{{PersonCard.UpdateUser}}</td>
                    <td>{{PersonCard.CreateDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{PersonCard.UpdateDate | date: 'dd/MM/yyyy' }}</td>
                    <td>{{PersonCard.Errors}}</td>
                    <td>{{(PersonCard.State == 0)?'Sin Procesar':((PersonCard.State == 1)?'Procesada':'Procesada con Errores')}}</td>
                    <td>
                        <fa-icon class="fa" [icon]="(PersonCard.Active)?'check':'times'"></fa-icon>
                    </td>
                    <td>
                        <button type="button" class="btn btn-sm btm-primary" (click)="EditPersonCard(content_person_card, PersonCard)">
                            <fa-icon class="fa" icon="edit"></fa-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <ngb-pagination class="col d-flex justify-content-center mt-2" [collectionSize]="CollectionSize" [pageSize]="PageSize" [(page)]="CurrentPage" [boundaryLinks]="true" (pageChange)="LoadPersonCards()">
            <ng-template ngbPaginationPages let-page let-pages="pages">
                <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                    <div class="form-group d-flex flex-nowrap px-2">
                        <label id="paginationInputLabel" for="paginationInput" class="col-form-label mr-2 ml-1">Página</label>
                        <input #i type="text" inputmode="numeric" pattern="[0-9]*" class="form-control custom-pages-input" id="paginationInput" [value]="CurrentPage" (keyup.enter)="SelectPage(i.value)" (blur)="SelectPage(i.value)" (change)="LoadPersonCards()" (input)="FormatInput($any($event).target)"
                            aria-labelledby="paginationInputLabel paginationDescription" />
                        <span id="paginationDescription" class="col-form-label text-nowrap px-2">
                          de {{pages.length}}</span>
                    </div>
                </li>
            </ng-template>
        </ngb-pagination>
    </div>
</block-ui>

<!-- Ventana modal-->
<ng-template #content_person_card let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Cédula</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="PersonCardForm">
            <div #Id class="form-group" hidden>
                <input type="number" class="form-control form-control-sm" formControlName="Id">
            </div>
            <div class="form-group">
                <label for="">Cédula</label>
                <input type="text" class="form-control form-control-sm" formControlName="Card">
            </div>
            <div class="form-group" hidden>
                <input type="number" class="form-control form-control-sm" formControlName="State">
            </div>
            <div class="form-check">
                <input type="checkbox" class="form-check-input" formControlName="Active" style="transform: scale(1.5);">
                <label class="form-check-label" for="exampleCheck1">Activo</label>
            </div>
        </form>
        <br>
        <div class="row">
            <div class="col-sm-4 offset-sm-4">

                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="StorePersonCard()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
            </div>
            <div class="col-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="ClosePersonCardModal()"><i class="fa fa-times-circle" aria-hidden="true"></i>
                    Cerrar&nbsp;
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #content_upload_cards let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Cargar cédulas desde archivo</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form class="row mb-3" [formGroup]="UploadFileFrom">
            <div class="col">
                <label class="">Acción</label>
                <select class="form-control form-control-sm" formControlName="Action">
                    <option value="CREATE" selected>Crear / Priorizar</option>
                    <option value="ENABLE">Habilitar</option>
                    <option value="DISABLE">Deshabilitar</option>
                </select>
            </div>

            <div class="d-flex align-items-end col">
                <button type="button" class="btn btn-light shadow-sm btn-sm col mr-4" (click)="DownloadMassiveTemplateFile()">Descargar Plantilla</button>
                <button type="button" class="btn btn-light shadow-sm btn-sm col" (click)="FileInput.click()">{{(UploadFileFrom.controls.File.value)?UploadFileFrom.controls.File.value:'Subir archivo'}}</button>
                <input hidden (change)="FileSelected($event, FileInput)" #FileInput type="file">
            </div>
        </form>
        <div class="tableCardFixHead">
            <table class="table table-striped table-sm">
                <thead style="background-color: #172749; color: white;">
                    <tr>
                        <th>Cédula</th>
                        <th>Resultado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let card of FileCardsResult">
                        <td>{{card.Card}}</td>
                        <td>{{card.Result}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-4 offset-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-sm btn-st float-right" (click)="PostCards()" [disabled]="!FileCards.length"><i class="fa fa-floppy-o" aria-hidden="true"></i> Continuar</button>
            </div>
            <div class="col-sm-4">
                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="CloseUploadCardsModal()"><i class="fa fa-times-circle" aria-hidden="true"></i>
                    Cerrar&nbsp;
                </button>
            </div>
        </div>
    </div>
</ng-template>